let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6qah4"), load("dzXtg")]).then(() => parcelRequire('2XV15'));